import { render, staticRenderFns } from "./ResidentOpen.vue?vue&type=template&id=c45bd5d6&scoped=true"
import script from "./ResidentOpen.vue?vue&type=script&lang=js"
export * from "./ResidentOpen.vue?vue&type=script&lang=js"
import style0 from "./ResidentOpen.vue?vue&type=style&index=0&id=c45bd5d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45bd5d6",
  null
  
)

export default component.exports